import React, { useState } from 'react';
import { Box, CardActionArea, CircularProgress } from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { TJobOffer } from '../../../types/JobOffer';
import { bulkDeleteJobOffer, deleteJobOffer } from '../../../apis/job';
import ConfirmDialog from '../../UserManagement/ConfirmDialog';
import './action.scss';
import AddJobOfferDialog from '../Add';

interface ActionJobOfferHeaderProps {
  jobOfferSelected: number[];
  getJobOfferData: () => void;
  jobOfferList: TJobOffer[];
  setJobOfferSelected: ([]) => void;
}
const ActionJobOfferHeader: React.FC<ActionJobOfferHeaderProps> = (props) => {
  const { jobOfferSelected, jobOfferList, getJobOfferData, setJobOfferSelected } = props;
  const [openAddJobOfferDialog, setOpenAddJobOfferDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const [selectJobOffer, setSelectJobOffer] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const findAndSelectJobOffer = (id: number) =>
    setSelectJobOffer(jobOfferList.filter((job: TJobOffer) => job.id === id)[0]);

  const onClickDeleteUser = () => {
    setLoading(true);
    setOpenConfirmDialog(false);

    if (jobOfferSelected.length === 1) {
      deleteJobOffer(jobOfferSelected[0])
        .then(() => {
          setJobOfferSelected([]);
          getJobOfferData();
        })
        .finally(() => setLoading(false));
    } else {
      bulkDeleteJobOffer(jobOfferSelected)
        .then(() => {
          setJobOfferSelected([]);
          getJobOfferData();
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <>
      <Box className='mainHeader'>
        <span>لیست فرصت های شغلی</span>

        <Box className='flexCenter' gap={1}>
          <CardActionArea className='actionBox' onClick={() => setOpenAddJobOfferDialog(true)}>
            <AddRoundedIcon color='secondary' />
          </CardActionArea>

          <CardActionArea
            disabled={jobOfferSelected.length !== 1}
            className='actionBox'
            onClick={() => {
              findAndSelectJobOffer(jobOfferSelected[0]);
              setOpenAddJobOfferDialog(true);
            }}
          >
            <BorderColorRoundedIcon color='secondary' />
          </CardActionArea>

          <CardActionArea
            disabled={jobOfferSelected.length === 0 || loading}
            className='actionBox'
            onClick={() => setOpenConfirmDialog(true)}
          >
            {loading ? (
              <Box p={0.4} className='flexCenter'>
                <CircularProgress size={15} color='primary' />
              </Box>
            ) : (
              <DeleteOutlineRoundedIcon color='secondary' />
            )}
          </CardActionArea>

          <CardActionArea className='actionBox' onClick={() => getJobOfferData()}>
            <RefreshRoundedIcon color='secondary' />
          </CardActionArea>
        </Box>
      </Box>

      <AddJobOfferDialog
        openAddUserDialog={openAddJobOfferDialog}
        closeDialog={() => {
          setOpenAddJobOfferDialog(false);
          if (selectJobOffer) setSelectJobOffer(null);
        }}
        getJobOfferData={getJobOfferData}
        selectJobOffer={selectJobOffer}
      />

      <ConfirmDialog
        openConfirmDialog={openConfirmDialog}
        closeDialog={() => setOpenConfirmDialog(false)}
        onSubmit={onClickDeleteUser}
        title='حذف کردن فرصت شفلی'
        description={`آیا از حذف  فرصت شغلی مطمئن هستید؟`}
      />
    </>
  );
};

export default ActionJobOfferHeader;
